import { FormEvent, useState } from "react";
import api, { errorStatus } from "../../api/account";
import { AuthUser } from "../../auth/types";

type SupportTicketProps = {
  user: AuthUser;
};

export default function SupportTicket({ user }: SupportTicketProps) {
  const [message, setMessage] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [ticketNumber, setTicketNumber] = useState<string | null>(null);
  const [error, setError] = useState("");

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const payload = { message: message.trim(), phone: phone.trim() };

    try {
      const number = await api.account.postSupportTicket(payload, user);
      setTicketNumber(number);
      setMessage("");
      setPhone("");
    } catch (err) {
      setError(
        `Failed to submit ticket (${
          errorStatus(err) ?? "network error"
        }). Please try again.`
      );
    }

    setLoading(false);
  };

  if (ticketNumber) {
    return (
      <div className="account-card account-card--wide support-success">
        <div className="support-success-icon">&#10003;</div>
        <div className="support-success-body-wrap">
          <h3 className="support-success-title">Ticket submitted!</h3>
          <p className="support-success-body">
            We've received your message and will get back to you shortly.
          </p>
          <div className="support-ticket-number">
            <span className="support-ticket-label">Your ticket number</span>
            <span className="support-ticket-value">#{ticketNumber}</span>
          </div>
          <p className="support-ticket-hint">
            Keep this number handy — you can use it to follow up with our
            support team.
          </p>
        </div>
        <button
          className="account-signout-btn"
          onClick={() => setTicketNumber(null)}
        >
          New Ticket
        </button>
      </div>
    );
  }

  return (
    <div className="account-card account-card--wide">
      <h2 className="account-card-title">Support</h2>
      <p className="support-intro">
        Need help? Submit a ticket and our team will respond as soon as
        possible.
      </p>
      <form className="support-form" onSubmit={handleSubmit}>
        <div className="support-fields">
          <div className="signin-field" style={{ flex: 1 }}>
            <label>
              Message <span className="support-required">*</span>
            </label>
            <textarea
              className="support-textarea"
              placeholder="Describe your issue or question…"
              rows={3}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />
          </div>
          <div className="signin-field support-phone-field">
            <label>
              Phone <span className="support-optional">(optional)</span>
            </label>
            <input
              type="tel"
              className="support-input"
              placeholder="+1 234 567 8900"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
        </div>
        {error && (
          <div className="signin-error" style={{ marginBottom: 10 }}>
            {error}
          </div>
        )}
        <button
          className="signin-btn support-submit-btn"
          type="submit"
          disabled={loading}
        >
          {loading ? "Submitting…" : "Submit Ticket"}
        </button>
      </form>
    </div>
  );
}
